import SqlTablesSection from "./SqlTablesSection";
import FileNamesSection from "./FileNamesSection";
import TableFieldsSection from "./TableFieldsSection";

export default function UseCaseForm() {
  return (
    <div className="ad-card ad-card-lg">

      {/* Header */}
      <div className="ad-card-header">
        <h5 className="ad-card-title">Company Role</h5>
      </div>

      <div style={{ padding: "1.5rem" }}>

        {/* Top Form Fields */}
        <div className="ad-grid-2">
          <div>
            <label className="ad-label">Company</label>
            <div className="ad-select-wrap">
              <select className="ad-select">
                <option value="">-- Select --</option>
              </select>
              <span className="ad-select-chevron">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </span>
            </div>
          </div>

          <div>
            <label className="ad-label">Role Name</label>
            <input
              type="text"
              className="ad-input"
              placeholder="Enter role name"
            />
          </div>
        </div>

        {/* SQL Tables + File Names */}
        <div className="ad-grid-2" style={{ marginTop: "1.5rem" }}>
          <SqlTablesSection />
          <FileNamesSection />
        </div>

        {/* Table Fields */}
        <div style={{ marginTop: "1.5rem" }}>
          <TableFieldsSection />
        </div>

        {/* Save Button */}
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "1.5rem", paddingTop: "1.25rem", borderTop: "1px solid #f1f5f9" }}>
          <button className="ad-btn ad-btn-green">
            Save
          </button>
        </div>

      </div>
    </div>
  );
}